<template>
    <Box :title="'维修处理('+Total+')'" :SearchParams="IsSee" @SearchParams="IsSee=true">
        <LoadingFooter
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            @scroll="IsSee=false"
        >
            <div class="commonItems" v-for="item in List" @click="ButtonName=='预处理'&&item.Pretreatment==null?advance(item):redirect(item)">
                <div>
                    <img src="@/assets/img/Icon_1.png"/>
                    <div>
                        <p class="ellipsis">{{item.EquName}}</p>
                        <div>
                            <div>
                                <p>资产编号：</p>
                                <p>规格型号：</p>
                                <p>使用科室：</p>
                            </div>
                            <div>
                                <p class="ellipsis">{{item.EquCode}}</p>
                                <p class="ellipsis">{{item.Size}}</p>
                                <p class="ellipsis">{{item.DepartmentName}}</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div :style="ButtonName=='预处理'&&item.Pretreatment==null?'background:#E85F1C':''">{{ButtonName=='预处理'&&item.Pretreatment==null?'预处理':'去处理'}}</div>
                    </div>
                </div>
                <div>
                    <span>启用日期</span>
                    <span>{{item.EnableDate}}</span>
                </div>
            </div>
        </LoadingFooter>
        <transition name="fade">
            <div class="menu" v-if="IsSee">
                <Field title="资产名称" placeholder="请选择" @manuconfirm='search.EquCode=arguments[0].a' type='manufacturer' name='assetsList'/>
                <Field title="报修科室" placeholder="请选择" @manuconfirm='search.DepartmentId=arguments[0].a' type='manufacturer' name='departmentList'/>
                <Field title="开始时间" placeholder="请选择" type="calendar" @onMessage="value => search.StartDate = value" />
                <Field title="结束时间" placeholder="请选择" type="calendar" @onMessage="value => search.EndDate = value" />
                <div class="search" @click="serach">查询</div>
            </div>
        </transition>
    </Box>
</template>

<script>
    import Field from '../../components/field/field.vue'
    import Box from '../../components/commonBox/commonBox'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'ServiceList',
        components: {
            Box,
            LoadingFooter,
            Field
        },
        data() {
            return {
                ButtonName:this.$route.params.SystemValue=='Y'?'预处理':'去处理',
                search:{
                    EquCode:null,
                    DepartmentId:null,
                    StartDate:null,
                    EndDate:null
                },
                loading: true,
                finished: false,
                List:[],
                IsSee:false,
                Total:0,
                page:1,
                ImageArray:[],//详情的图片对象
            }
        },
        activated(){
          this.Total=0;
          this.List=[];
          this.loadDataDefault();
          
        },
        methods: {
            serach(){
              this.page=1;
              this.List=[];
              this.loadDataDefault();
              this.IsSee=false;
            },
            onLoad() {
               if (!this.loading && !this.finished) {
                   this.page += 1;
                   this.loadDataDefault();
               }
            },loadDataDefault(){
                this.$post('api/Dispatch/DispatchList',{
                    RepairStatus:'6',
                    EquCode:this.search.EquCode,
                    RepairOrder:'',
                    DepartmentId:this.search.DepartmentId,
                    UserCode:this.$UserInfo.UserId,
                    Store:this.$UserInfo.StoreCode,
                    SortType:'',
                    AssignOrConfirm:'1',
                    StartDate:this.search.StartDate,
                    EndDate:this.search.EndDate,
                    PageIndex:this.page,
                    PageSize:10,
                    Token:'123456'
                }).then(result=>{
                    if(result.DispatchList){
                        this.Total=result.Total;
                        for(let i=0;i<result.DispatchList.length;i++){
                            this.List.push(result.DispatchList[i]);
                        }
                         if (this.page*10>=result.Total) {
                             this.loading = false;
                             this.finished = true;
                         }else {
                             this.loading=false;
                             this.finished=true;
                         }
                    }else {
                        this.loading=false;
                        this.finished=true;
                    }
                })
            },redirect(item){
                 let ImageArray=[];
                 let ProcessDefault={
                     RepairMark:'',
                     AccessoriesMoney:0,
                     MaintainMoney:0,
                     RepairTypeName:item.RepairTypeName,
                     RepairType:item.RepairType,
                     WXGS:0,
                     TotalMoney:0
                 }
                this.$get('api/Repair/MaintenanceOther',{
                    WXDH:item.RepairOrder,
                    JCHH:'1'
                }).then(result=>{
                   //维修进程的处理
                   if(result.ProcessDefault.length>0){
                       let data=result.ProcessDefault[0];
                       ProcessDefault.RepairMark=data.RepairMark;
                       ProcessDefault.AccessoriesMoney=data.AccessoriesMoney?data.AccessoriesMoney:0;
                       ProcessDefault.MaintainMoney=data.MaintainMoney?data.MaintainMoney:0;//维修费用
                       ProcessDefault.RepairTypeName=data.RepairTypeName;
                       ProcessDefault.RepairType=data.RepairType;
                       ProcessDefault.WXGS=data.WXGS?data.WXGS:0;
                       ProcessDefault.TotalMoney=ProcessDefault.AccessoriesMoney+ProcessDefault.MaintainMoney;
                   };

                    //图片处理
                    result.accessory.forEach(function(item,index){
                        ImageArray.push({
                            HH:item.HH,
                            url:item.Repath,
                            Repath:item.WJLJ
                        });
                    })

                    this.skip(item,ProcessDefault,ImageArray).then(res=>{
                        this.$Bus.$emit('selectAccessories',result.accessories);//配件
                        this.$Bus.$emit('selectStaff',result.serviceman);//人员
                        this.$Bus.$emit('YSRKDelete',ImageArray);//图片
                    })
                })
            },skip(item,ProcessDefault,ImageArray){
                 return new Promise((resolve, reject) => {
                     this.$router.push({name: 'Pending', params: {item,ProcessDefault,ImageArray,SystemValue:this.$route.params.SystemValue}});
                     resolve();
                 })
            },advance(item){//预处理
                this.$router.push({name: 'Advance', params: {item}});
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;
        transition: all .5s;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/serviceList/serviceList.vue